import { z } from 'zod';
import { CostNegotiationMode } from '../../../../IPA/Negociacoes/pages/NegociacaoFornecedor/costNegotiation';

export const supplierNegotiationConfigSchema = z.object({
  id: z.string().optional(),
  negotiationCost: z.nativeEnum(CostNegotiationMode),
});

export type SupplierNegotiationConfigSchema = z.infer<typeof supplierNegotiationConfigSchema>;
